// exportera ut konstanter som vi använder i resten av programmet för att slippa jobba med strängar.
export const setChannelsExcludedChannels = "setChannelsExcludedChannels";
export const setChannelsQuery = "setChannelsQuery";
export const setChannelsRoFQuery = "setChannelsRoFQuery";
export const setChannelsResults = "setChannelsResults";
export const setChannelsResultsColumns = "setChannelsResultsColumns";
export const setChannelsSummary = "setChannelsSummary";
export const setChannelsColumnTypes = "setChannelsColumnTypes";
export const setChannelsInitStatus = "setChannelsInitStatus";
export const setChannelsQueryForAPI = "setChannelsQueryForAPI";
export const setChannelsTimeshift = "setChannelsTimeshift";
export const setChannelsChannels = "setChannelsChannels";
export const setChannelsChannelHouses = "setChannelsChannelHouses";
export const setChannelsRoFResults = "setChannelsRoFResults";
export const setChannelsDayparts = "setChannelsDayparts";
export const setChannelsStartdate = "setChannelsStartdate";
export const setChannelsEnddate = "setChannelsEnddate";
export const setChannelsColumnFieldsOptions = "setChannelsColumnFieldsOptions";
export const setChannelsDisplayColumnFieldsOptions =
  "setChannelsDisplayColumnFieldsOptions";
export const setChannelsAllWithStarSelected = "setChannelsAllWithStarSelected";
export const setChannelsWeekdays = "setChannelsWeekdays";
export const setChannelsRoFResultsLoadDetails =
  "setChannelsRoFResultsLoadDetails";
export const setChannelsSumVisible = "setChannelsSumVisible";
export const setChannelsGroupBy = "setChannelsGroupBy";

export const setQueryCostData = "setChannelsQueryCostData";
export const setQueryCostLoading = "setChannelsQueryCostLoading";
export const setQueryCostError = "setChannelsQueryCostError";
export const setChannelsMeasures = "setChannelsMeasures";
export const setDefaultChannelsQuery = "setDefaultChannelsQuery";
export const setHasSetDefaultChannelsQuery = "setHasSetDefaultChannelsQuery";

